import ACTIONS, { FETCH_STATUS } from '../app.constants';
import {
    ApplicationList,
    Application,
    AuditHistoryList,
    ChangeFilterAction,
    LicenseListFiltersType,
    LicenseTypeListType,
    PaginationAndLoadingData,
    Form,
    ViolationList,
    InspectionList,
    CommentList,
    Violation,
    Comment,
    AccountingTransactionList,
    Inspection,
    License,
    MergeTemplate,
    LicenseTypeConfiguration,
} from '../modules/application/types';
import { LimitAndSkipData, MergeQueueHistory } from '../modules/calendar/types';

import { Person } from '../modules/person/types';
import { NotificationType } from '../modules/site/types';

export const getApplicationList = {
    pending: (data: PaginationAndLoadingData) => ({
        type: ACTIONS.GET_APPLICATIONS_LIST.PENDING,
        data,
    }),
    success: (data: ApplicationList, pageNumber: number, licensesCount: number) => ({
        type: ACTIONS.GET_APPLICATIONS_LIST.SUCCESS,
        data,
        pageNumber,
        licensesCount,
    }),
    error: (error: Error) => ({
        type: ACTIONS.GET_APPLICATIONS_LIST.ERROR,
        error,
    }),
};

export const getApplicationListBegin = (data: PaginationAndLoadingData) => {
    return {
        type: ACTIONS.GET_APPLICATIONS_LIST_BEGIN,
        status: true,
        data,
    };
};

export const getApplicationDetail = {
    pending: {
        type: ACTIONS.GET_APPLICATIONS_DETAIL.PENDING,
        status: FETCH_STATUS.LOADING,
    },
    success: (license: Application, licenseType: LicenseTypeConfiguration, editForm: Form | undefined) => ({
        type: ACTIONS.GET_APPLICATIONS_DETAIL.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        data: {
            license,
            licenseType,
            editForm,
        },
    }),
    error: (error: Error) => ({
        type: ACTIONS.GET_APPLICATIONS_DETAIL.ERROR,
        status: FETCH_STATUS.ERROR,
        error,
    }),
};

export const getApplicationDetailBegin = (id: string) => {
    return {
        type: ACTIONS.GET_APPLICATIONS_DETAIL_BEGIN,
        payload: { id },
    };
};

export const deleteLicenseFileState = {
    success: () => ({
        type: ACTIONS.DELETE_LICENSE_FILE_STATE.SUCCESS,
    }),
    error: (error: NotificationType) => ({
        type: ACTIONS.DELETE_LICENSE_FILE_STATE.ERROR,
        error,
    }),
};

export const deleteLicenseFile = (error?: Error) => ({
    type: ACTIONS.DELETE_LICENSE_FILE,
    error,
});

export const getLicenseAccounting = {
    pending: {
        type: ACTIONS.GET_LICENSE_ACCOUNTING.PENDING,
        status: FETCH_STATUS.LOADING,
    },
    success: (data: AccountingTransactionList, paginationData: LimitAndSkipData) => ({
        type: ACTIONS.GET_LICENSE_ACCOUNTING.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        data,
        paginationData,
    }),
    error: (error: Error) => ({
        type: ACTIONS.GET_LICENSE_ACCOUNTING.ERROR,
        status: FETCH_STATUS.ERROR,
        error,
    }),
};

export const getLicenseAccountingBegin = (id: string, paginationData: LimitAndSkipData) => {
    return {
        type: ACTIONS.GET_LICENSE_ACCOUNTING_BEGIN,
        payload: { id },
        paginationData,
    };
};

export const getAuditHistory = {
    pending: {
        type: ACTIONS.GET_AUDIT_HISTORY.PENDING,
        status: FETCH_STATUS.LOADING,
    },
    success: (data: AuditHistoryList, paginationData: LimitAndSkipData) => ({
        type: ACTIONS.GET_AUDIT_HISTORY.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        data,
        paginationData,
    }),
    error: (error: Error) => ({
        type: ACTIONS.GET_AUDIT_HISTORY.ERROR,
        status: FETCH_STATUS.ERROR,
        error,
    }),
};

export const getAuditHistoryListBegin = (id: string, entityType: string, paginationData: LimitAndSkipData) => {
    return {
        type: ACTIONS.GET_AUDIT_HISTORY_BEGIN,
        payload: { id, entityType, paginationData },
    };
};

export const downloadFileDocumentBegin = (applicationId: string, fileId: string, fileName: string) => {
    return {
        type: ACTIONS.DOWNLOAD_FILE_DOCUMENT_BEGIN,
        payload: { applicationId, fileId, fileName },
    };
};

export const licenseSearch = {
    pending: (data: string) => ({
        type: ACTIONS.LICENSE_SEARCH.PENDING,
        status: FETCH_STATUS.LOADING,
        data,
    }),
    success: (data: ApplicationList) => ({
        type: ACTIONS.LICENSE_SEARCH.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        data,
    }),
    error: (error: Error) => ({
        type: ACTIONS.LICENSE_SEARCH.ERROR,
        error,
        status: FETCH_STATUS.ERROR,
    }),
};

export const updateLicense = {
    pending: () => ({
        type: ACTIONS.UPDATE_LICENSE.PENDING,
        status: FETCH_STATUS.LOADING,
    }),
    success: () => ({
        type: ACTIONS.UPDATE_LICENSE.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
    }),
    error: (error: Error) => ({
        type: ACTIONS.UPDATE_LICENSE.ERROR,
        error,
        status: FETCH_STATUS.ERROR,
    }),
};

export const LicenseSearchBegin = (data: string) => {
    return {
        type: ACTIONS.LICENSE_SEARCH_BEGIN,
        payload: { data },
    };
};

export const updateLicenseBegin = (data: License, licenseId: string) => {
    return {
        type: ACTIONS.UPDATE_LICENSE_BEGIN,
        payload: { data, licenseId },
    };
};
export const changeLicenseFilters = (data: ChangeFilterAction) => {
    return {
        type: ACTIONS.CHANGE_LICENSE_FILTERS,
        payload: { data },
    };
};
export const applyFilters = (data: LicenseListFiltersType, paginationData: PaginationAndLoadingData) => {
    return {
        type: ACTIONS.APPLY_FILTERS,
        payload: { data },
        data: paginationData,
    };
};

export const exportLicenses = (data: LicenseListFiltersType) => {
    return {
        type: ACTIONS.EXPORT_LICENSES,
        payload: { data },
    };
};

export const getLicenseTypes = {
    pending: {
        type: ACTIONS.GET_LICENSE_TYPES.PENDING,
    },
    success: (data: LicenseTypeListType) => ({
        type: ACTIONS.GET_LICENSE_TYPES.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        data,
    }),
    error: (error: Error) => ({
        type: ACTIONS.GET_LICENSE_TYPES.ERROR,
        error,
        status: FETCH_STATUS.ERROR,
    }),
};

export const getLicenseTypesBegin = () => {
    return {
        type: ACTIONS.GET_LICENSE_TYPES_BEGIN,
    };
};

export const getViolationList = {
    pending: {
        type: ACTIONS.GET_VIOLATION_LIST.PENDING,
    },
    success: (data: ViolationList, paginationData: LimitAndSkipData) => ({
        type: ACTIONS.GET_VIOLATION_LIST.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        data,
        paginationData,
    }),
    error: (error: Error) => ({
        type: ACTIONS.GET_VIOLATION_LIST.ERROR,
        status: FETCH_STATUS.ERROR,
        error,
    }),
};

export const getViolationListBegin = (id: string, paginationData: LimitAndSkipData) => {
    return {
        type: ACTIONS.GET_VIOLATION_LIST_BEGIN,
        payload: { id },
        paginationData,
    };
};

export const getInspectionList = {
    pending: {
        type: ACTIONS.GET_INSPECTION_LIST.PENDING,
    },
    success: (data: InspectionList, paginationData: LimitAndSkipData, inspectionCount: number) => ({
        type: ACTIONS.GET_INSPECTION_LIST.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        data,
        paginationData,
        inspectionCount,
    }),
    error: (error: Error) => ({
        type: ACTIONS.GET_INSPECTION_LIST.ERROR,
        status: FETCH_STATUS.ERROR,
        error,
    }),
};

export const getInspectionListBegin = (id: string, paginationData: LimitAndSkipData) => {
    return {
        type: ACTIONS.GET_INSPECTION_LIST_BEGIN,
        payload: { id },
        paginationData,
    };
};

export const getCommentList = {
    pending: {
        type: ACTIONS.GET_COMMENT_LIST.PENDING,
    },
    success: (data: CommentList, paginationData: LimitAndSkipData) => ({
        type: ACTIONS.GET_COMMENT_LIST.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        data,
        paginationData,
    }),
    error: (error: Error) => ({
        type: ACTIONS.GET_COMMENT_LIST.ERROR,
        status: FETCH_STATUS.ERROR,
        error,
    }),
};

export const getCommentListBegin = (id: string, paginationData: LimitAndSkipData) => {
    return {
        type: ACTIONS.GET_COMMENT_LIST_BEGIN,
        payload: { id },
        paginationData,
    };
};

export const addComment = {
    pending: {
        type: ACTIONS.ADD_COMMENT.PENDING,
        status: FETCH_STATUS.LOADING,
    },
    success: (data: Comment) => ({
        type: ACTIONS.ADD_COMMENT.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        data,
    }),
    error: (error: Error) => ({
        type: ACTIONS.ADD_COMMENT.ERROR,
        error,
        status: FETCH_STATUS.ERROR,
    }),
};

export const addCommentBegin = (data: Comment) => {
    return {
        type: ACTIONS.ADD_COMMENT_BEGIN,
        payload: { data },
    };
};

export const getCategoryList = {
    pending: {
        type: ACTIONS.GET_CATEGORY_LIST.PENDING,
    },
    success: (data: any) => ({
        type: ACTIONS.GET_CATEGORY_LIST.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        data,
    }),
    error: (error: Error) => ({
        type: ACTIONS.GET_CATEGORY_LIST.ERROR,
        status: FETCH_STATUS.ERROR,
        error,
    }),
};

export const getCategoryListBegin = (payload: { licenseTypeId: string }) => {
    return {
        type: ACTIONS.GET_CATEGORY_LIST_BEGIN,
        payload,
    };
};

export const addViolation = {
    pending: {
        type: ACTIONS.ADD_VIOLATION.PENDING,
        status: FETCH_STATUS.LOADING,
    },
    success: (data: Violation[]) => ({
        type: ACTIONS.ADD_VIOLATION.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        data,
    }),
    error: (error: Error) => ({
        type: ACTIONS.ADD_VIOLATION.ERROR,
        error,
        status: FETCH_STATUS.ERROR,
    }),
};

export const addViolationBegin = (data: Violation) => {
    return {
        type: ACTIONS.ADD_VIOLATION_BEGIN,
        payload: { data },
    };
};

export const addInspection = {
    pending: {
        type: ACTIONS.ADD_INSPECTION.PENDING,
        status: FETCH_STATUS.LOADING,
    },
    success: (data: Inspection) => ({
        type: ACTIONS.ADD_INSPECTION.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        data,
    }),
    error: (error: Error) => ({
        type: ACTIONS.ADD_INSPECTION.ERROR,
        error,
        status: FETCH_STATUS.ERROR,
    }),
};

export const addInspectionBegin = (data: Inspection) => {
    return {
        type: ACTIONS.ADD_INSPECTION_BEGIN,
        payload: { data },
    };
};

export const deleteInspectionRecord = {
    pending: {
        type: ACTIONS.DELETE_INSPECTION_RECORD.PENDING,
        status: FETCH_STATUS.LOADING,
    },
    success: (inspectionId: string) => ({
        type: ACTIONS.DELETE_INSPECTION_RECORD.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        payload: { inspectionId },
    }),
    error: (error: Error) => ({
        type: ACTIONS.DELETE_INSPECTION_RECORD.ERROR,
        status: FETCH_STATUS.ERROR,
        error,
    }),
};

export const deleteInspectionRecordBegin = (inspectionId: string) => {
    return {
        type: ACTIONS.DELETE_INSPECTION_RECORD_BEGIN,
        payload: { inspectionId },
    };
};

export const getUserList = {
    pending: {
        type: ACTIONS.GET_USER_LIST.PENDING,
    },
    success: (data: any) => ({
        type: ACTIONS.GET_USER_LIST.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        data,
    }),
    error: (error: Error) => ({
        type: ACTIONS.GET_USER_LIST.ERROR,
        status: FETCH_STATUS.ERROR,
        error,
    }),
};

export const getUserListBegin = () => {
    return {
        type: ACTIONS.GET_USER_LIST_BEGIN,
    };
};

export const getInspectionType = {
    pending: {
        type: ACTIONS.GET_INSPECTION_TYPE.PENDING,
    },
    success: (data: any) => ({
        type: ACTIONS.GET_INSPECTION_TYPE.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        data,
    }),
    error: (error: Error) => ({
        type: ACTIONS.GET_INSPECTION_TYPE.ERROR,
        status: FETCH_STATUS.ERROR,
        error,
    }),
};

export const getInspectionTypeBegin = (licenseTypeId: string) => {
    return {
        type: ACTIONS.GET_INSPECTION_TYPE_BEGIN,
        payload: licenseTypeId,
    };
};

export const deleteViolation = {
    pending: {
        type: ACTIONS.DELETE_VIOLATION.PENDING,
        status: FETCH_STATUS.LOADING,
    },
    success: (violationId: string) => ({
        type: ACTIONS.DELETE_VIOLATION.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        payload: { violationId },
    }),
    error: (error: Error) => ({
        type: ACTIONS.DELETE_VIOLATION.ERROR,
        status: FETCH_STATUS.ERROR,
        error,
    }),
};

export const addLicense = {
    pending: {
        type: ACTIONS.ADD_LICENSE.PENDING,
        status: FETCH_STATUS.LOADING,
    },
    success: (data: any) => ({
        type: ACTIONS.ADD_LICENSE.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        payload: data,
    }),
    error: (error: Error) => ({
        type: ACTIONS.ADD_LICENSE.ERROR,
        status: FETCH_STATUS.ERROR,
        error,
    }),
};

export const deleteViolationBegin = (violationId: string) => {
    return {
        type: ACTIONS.DELETE_VIOLATION_BEGIN,
        payload: { violationId },
    };
};

export const getInspectionDetail = {
    pending: {
        type: ACTIONS.GET_INSPECTION_DETAIL.PENDING,
        status: FETCH_STATUS.LOADING,
    },
    success: (data: { editForm: Form }) => ({
        type: ACTIONS.GET_INSPECTION_DETAIL.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        data,
    }),
    error: (error: Error) => ({
        type: ACTIONS.GET_INSPECTION_DETAIL.ERROR,
        status: FETCH_STATUS.ERROR,
        error,
    }),
};

export const getMergeTemplates = {
    pending: {
        type: ACTIONS.GET_MERGE_TEMPLATES.PENDING,
        status: FETCH_STATUS.LOADING,
    },
    success: (data: MergeTemplate) => ({
        type: ACTIONS.GET_MERGE_TEMPLATES.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        data,
    }),
    error: (error: Error) => ({
        type: ACTIONS.GET_MERGE_TEMPLATES.ERROR,
        status: FETCH_STATUS.ERROR,
        error,
    }),
};

export const mergeDocuments = {
    pending: {
        type: ACTIONS.DOWNLOAD_DOCUMENT.PENDING,
        status: FETCH_STATUS.LOADING,
    },
    success: (data: any) => ({
        type: ACTIONS.DOWNLOAD_DOCUMENT.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        data,
    }),
    error: (error: Error) => ({
        type: ACTIONS.DOWNLOAD_DOCUMENT.ERROR,
        status: FETCH_STATUS.ERROR,
        error,
    }),
};

export const personSearch = {
    pending: (data: string) => ({
        type: ACTIONS.PERSON_SEARCH.PENDING,
        status: FETCH_STATUS.LOADING,
        data,
    }),
    success: (data: Person[]) => ({
        type: ACTIONS.PERSON_SEARCH.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        data,
    }),
    error: (error: Error) => ({
        type: ACTIONS.PERSON_SEARCH.ERROR,
        error,
        status: FETCH_STATUS.ERROR,
    }),
};

export const getPrintDocumentsHistoryList = {
    pending: {
        type: ACTIONS.PRINT_DOCUMENTS_HISTORY_LIST.PENDING,
        status: FETCH_STATUS.LOADING,
    },
    success: (data: MergeQueueHistory[], paginationData: LimitAndSkipData) => ({
        type: ACTIONS.PRINT_DOCUMENTS_HISTORY_LIST.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        data,
        paginationData,
    }),
    error: (error: Error) => ({
        type: ACTIONS.PRINT_DOCUMENTS_HISTORY_LIST.ERROR,
        status: FETCH_STATUS.ERROR,
        error,
    }),
};

export const setActiveTab = (activeTab: string) => {
    return {
        type: ACTIONS.SET_ACTIVE_TAB,
        activeTab,
    };
};

export const getInspectionDetailBegin = (inspectionId: string) => {
    return {
        type: ACTIONS.GET_INSPECTION_DETAIL_BEGIN,
        inspectionId,
    };
};

export const addLicenseBegin = (license: License, history: any) => {
    return {
        type: ACTIONS.ADD_LICENSE_BEGIN,
        payload: { license, history },
    };
};

export const getMergeTemplatesBegin = (payload: any) => {
    return {
        type: ACTIONS.GET_MERGE_TEMPLATES_BEGIN,
        payload,
    };
};

export const mergeDocumentsBegin = (
    templateId: string,
    fileName: string,
    printHistoryId: string,
    records?: string[],
    outputFormat?: string,
) => {
    return {
        type: ACTIONS.DOWNLOAD_DOCUMENT_BEGIN,
        payload: { templateId, fileName, printHistoryId, records, outputFormat },
    };
};

export const getPrintDocumentsHistoryListBegin = (payload: string, data: LimitAndSkipData) => {
    return {
        type: ACTIONS.PRINT_DOCUMENTS_HISTORY_LIST_BEGIN,
        status: true,
        data,
        payload,
    };
};

export const setLicenseColumnSort = (orderBy: string, orderCol: string) => {
    return {
        type: ACTIONS.SET_LICENSE_COLUMN_SORT,
        payload: { orderBy, orderCol },
    };
};
